import { useTitle } from "@vueuse/core";
import { createRouter, createWebHistory } from "vue-router/auto";
import { PROD } from "@/constants";
import { useMobile } from "@/helpers/ui";
import { useAuthStore } from "@/stores/auth";
import { useMenuStore } from "@/stores/menu";

export const router = createRouter({
	history: createWebHistory(PROD ? "#" : "/")
});

const workshopDocument = import.meta.env.DEV && window.location.pathname.startsWith("/dev/");

router.beforeEach(async (to, from, next) => {
	// The standalone workshop does not initialize the normal app or its socket.
	if (workshopDocument && !to.path.startsWith("/dev/")) {
		window.location.assign(to.fullPath);
		next(false);
		return;
	}
	if (PROD && to.path.startsWith("/dev/")) {
		next("/");
		return;
	}

	if (import.meta.env.DEV && to.path.startsWith("/dev/")) {
		useTitle(to.path.startsWith("/dev/lobby") ? "Lobby workshop - Belot Masters" : "Play workshop - Belot Masters");
		next();
		return;
	}

	// always close menu on route change
	const menuStore = useMenuStore();
	menuStore.opened = false;

	const auth = useAuthStore();
	await auth.ready;
	const loggedIn = auth.loggedIn;

	console.log(
		"BEFORE EACH name:[%s] path:[%s] to-meta:[%s] loggedIn:[%s]",
		to.name,
		to.fullPath,
		JSON.stringify(to.meta),
		loggedIn
	);

	if (typeof to.name === "string" && to.name.length > 0 && !to.name.startsWith("/")) {
		useTitle(to.name + " - Belot Masters");
	}

	if (to.meta.requiresAuth) {
		if (!loggedIn) {
			next({ path: "/login" });
			return;
		}

		if (to.meta.requiresAdmin) {
			if (!auth.isAdmin) {
				next({ path: "/" });
				return;
			}
		}
	}

	if (to.meta.requiresNoAuth) {
		if (loggedIn) {
			next({ path: "/" });
			return;
		}
	}

	if (to.name === "/profile/") {
		// redirect to my profile
		next({ name: `/profile/[id]`, params: { id: auth.username } });
	}

	// Settings mobile view only on mobile
	if (to.path.endsWith("/settings") && !useMobile.value) {
		next("/settings/profile");
	}

	next();
});
